import React from "react";
import router from "./routes/index";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import ChunkErrorHandler from "./components/ChunkErrorHandler/ChunkErrorHandler";

const App = () => {
  return (
    <ThemeProvider>
      <div>
        <ChunkErrorHandler />
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
};

export default App;
